import { Routes } from '@angular/router';

const termsConditionsRoute = {
    path: 'terms-conditions',
    loadChildren: () =>
        import('../pages/terms-conditions/terms-conditions.routes').then(
            m => m.TERMS_CONDITIONS_ROUTES
        ),
};

const privacyPolicyRoute = {
    path: 'privacy-policy',
    loadChildren: () =>
        import('../pages/privacy-policy/privacy-policy.routes').then(
            m => m.PRIVACY_POLICY_ROUTES
        ),
};

const subscriptionBillingPolicyRoute = {
    path: 'subscription-billing-policy',
    loadChildren: () =>
        import('../pages/subscription-billing-policy/subscription-billing-policy.routes').then(
            m => m.SUBSCRIPTION_BILLING_POLICY_ROUTES
        ),
};

const acceptableUseRoute = {
    path: 'acceptable-use',
    loadChildren: () =>
        import('../pages/acceptable-use/acceptable-use.routes').then(
            m => m.ACCEPTABLE_USE_ROUTES
        ),
};

const cookiePolicyRoute = {
    path: 'cookie-policy',
    loadChildren: () =>
        import('../pages/cookie-policy/cookie-policy.routes').then(
            m => m.COOKIE_POLICY_ROUTES
        ),
};

const supportPolicyRoute = {
    path: 'support-policy',
    loadChildren: () =>
        import('../pages/support-policy/support-policy.routes').then(
            m => m.SUPPORT_POLICY_ROUTES
        ),
};

export const policyRoutes: Routes = [
    termsConditionsRoute,
    privacyPolicyRoute,
    subscriptionBillingPolicyRoute,
    acceptableUseRoute,
    cookiePolicyRoute,
    supportPolicyRoute,
];
